Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _groupBy3=require("lodash/groupBy");var _groupBy4=_interopRequireDefault(_groupBy3);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==="function"?Symbol.iterator:"@@iterator"](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==="function"?Symbol.iterator:"@@iterator")in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);

var _helperMethods=require("../victory-chart/helper-methods");var _helperMethods2=_interopRequireDefault(_helperMethods);
var _helperMethods3=require("./helper-methods");var _helperMethods4=_interopRequireDefault(_helperMethods3);
var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var fallbackProps={
width:450,
height:300,
padding:50};var


VictoryZoom=function(_Component){_inherits(VictoryZoom,_Component);























function VictoryZoom(props){_classCallCheck(this,VictoryZoom);var _this=_possibleConstructorReturn(this,(VictoryZoom.__proto__||Object.getPrototypeOf(VictoryZoom)).call(this,
props));

var chart=_react2.default.Children.only(_this.props.children);var _Helpers$getRange=
_victoryCore.Helpers.getRange(
_victoryCore.Helpers.modifyProps(chart.props,{},"chart"),
"x"),_Helpers$getRange2=_slicedToArray(_Helpers$getRange,2),rangex1=_Helpers$getRange2[0],rangex0=_Helpers$getRange2[1];


_this.plottableWidth=rangex0-rangex1;
_this.width=chart.props.width||fallbackProps.width;
_this.state={domain:props.zoomDomain||_this.getDataDomain()};

_this.events=_this.getEvents(props.allowZoom);
_this.clipDataComponents=_this.clipDataComponents.bind(_this);
_this.getTimer=_this.getTimer.bind(_this);return _this;
}_createClass(VictoryZoom,[{key:"getChildContext",value:function getChildContext()

{
return{
getTimer:this.getTimer};

}},{key:"getTimer",value:function getTimer()

{
if(!this.timer){
this.timer=new _victoryCore.Timer();
}
return this.timer;
}},{key:"componentWillMount",value:function componentWillMount()

{var _this2=this;
this.getChartRef=function(chart){_this2.chartRef=chart;};
}},{key:"componentWillUnmount",value:function componentWillUnmount()

{
this.getTimer().stop();
}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(_ref)

{var nextAllowZoom=_ref.allowZoom,nextDomain=_ref.zoomDomain;var _props=
this.props,allowZoom=_props.allowZoom,zoomDomain=_props.zoomDomain;
if(!(0,_isEqual3.default)(zoomDomain,nextDomain)){
this.setState({domain:nextDomain});
}

if(allowZoom!==nextAllowZoom){
this.events=this.getEvents(nextAllowZoom);
}
}},{key:"getDataDomain",value:function getDataDomain()

{
var chart=_react2.default.Children.only(this.props.children);
var chartChildren=_react2.default.Children.toArray(chart);

return{
x:_helperMethods2.default.getDomain(chart.props,"x",chartChildren)};

}},{key:"getEvents",value:function getEvents(

allowZoom){var _this3=this;
return[{
target:"parent",
eventHandlers:_extends({
onMouseDown:function onMouseDown(evt){
_this3.targetBounds=_this3.chartRef.getSvgBounds();
var x=evt.clientX-_this3.targetBounds.left;
_this3.isPanning=true;
_this3.startX=x;
_this3.lastDomain=_this3.state.domain;
},
onMouseUp:function onMouseUp(){_this3.isPanning=false;},
onMouseLeave:function onMouseLeave(){_this3.isPanning=false;},
onMouseMove:function onMouseMove(evt){
var clientX=evt.clientX;
if(_this3.isPanning){
requestAnimationFrame(function(){
var domain=_this3.getDataDomain();
var delta=_this3.startX-(clientX-_this3.targetBounds.left);
var calculatedDx=delta/_this3.getDomainScale();
var nextXDomain=_helperMethods4.default.pan(_this3.lastDomain.x,domain.x,calculatedDx);
_this3.setDomain({x:nextXDomain});
_this3.setState({domain:{x:nextXDomain}});
});
}
}},
allowZoom&&{onWheel:function onWheel(evt){
evt.preventDefault();
var deltaY=evt.deltaY;
requestAnimationFrame(function(){var
x=_this3.state.domain.x;
var xBounds=_this3.getDataDomain().x;


var nextXDomain=_helperMethods4.default.scale(x,xBounds,1+deltaY/300);
_this3.setDomain({x:nextXDomain});
});
}})}];


}},{key:"setDomain",value:function setDomain(

domain){var _this4=this;var
onDomainChange=this.props.onDomainChange;
this.getTimer().bypassAnimation();
this.setState({domain:domain},function(){return _this4.getTimer().resumeAnimation();});
if(onDomainChange){onDomainChange(domain);}
}},{key:"getDomainScale",value:function getDomainScale()

{var _lastDomain$x=_slicedToArray(
this.lastDomain.x,2),from=_lastDomain$x[0],to=_lastDomain$x[1];
var ratio=this.targetBounds.width/this.width;
var absoluteAxisWidth=ratio*this.plottableWidth;
return absoluteAxisWidth/(to-from);
}},{key:"clipDataComponents",value:function clipDataComponents(

children,props){var _groupBy2=
(0,_groupBy4.default)(children,function(child){
return child.type.displayName==="VictoryAxis"?
"axes":
"data";
}),data=_groupBy2.data,_groupBy2$axes=_groupBy2.axes,axes=_groupBy2$axes===undefined?[]:_groupBy2$axes;var _Helpers$getRange3=

_victoryCore.Helpers.getRange(props,"x"),_Helpers$getRange4=_slicedToArray(_Helpers$getRange3,2),rangex0=_Helpers$getRange4[0],rangex1=_Helpers$getRange4[1];

return[
_react2.default.cloneElement(this.props.clipContainerComponent,{
key:"ZoomClipContainer",
clipWidth:rangex1-rangex0,
clipHeight:fallbackProps.height,
translateX:rangex0,
children:data})].concat(_toConsumableArray(

axes));

}},{key:"renderChart",value:function renderChart(

chartElement,props){
return _react2.default.cloneElement(chartElement,props);
}},{key:"render",value:function render()

{var _chart$props$events;
var chart=_react2.default.Children.only(this.props.children);
var nextProps=(0,_assign3.default)({},chart.props,{
events:chart.props.events?(_chart$props$events=chart.props.events).unshift.apply(_chart$props$events,_toConsumableArray(this.events)):this.events,
domain:this.state.domain,
ref:this.getChartRef,
modifyChildren:this.clipDataComponents});


return this.renderChart(chart,nextProps);
}}]);return VictoryZoom;}(_react.Component);VictoryZoom.displayName="VictoryZoom";VictoryZoom.role="zoom";VictoryZoom.propTypes={children:_react.PropTypes.node,zoomDomain:_react.PropTypes.shape({x:_victoryCore.PropTypes.domain,y:_victoryCore.PropTypes.domain}),onDomainChange:_react.PropTypes.func,clipContainerComponent:_react.PropTypes.element.isRequired,allowZoom:_react.PropTypes.bool};VictoryZoom.childContextTypes={getTimer:_react2.default.PropTypes.func};VictoryZoom.defaultProps={clipContainerComponent:_react2.default.createElement(_victoryCore.VictoryClipContainer,null),allowZoom:true};exports.default=


VictoryZoom;


/*****************
 ** WEBPACK FOOTER
 ** ./~/victory-chart/lib/components/victory-zoom/victory-zoom.js
 ** module id = 663
 ** module chunks = 0
 **/